const HomeTranslationEn = {
    legal_terms: 'Legal terms',
    contact: 'Contact',
};

export default HomeTranslationEn;